import { Injectable } from '@angular/core';
import { AppConfig } from './app.config';
import { LogService } from './services/log.service';


@Injectable()
export class FeatureFlagService {
    constructor(private logger: LogService) { }

    featureOff(featureName: string) {
        // // Read the value from the config service
        // console.log(`Service | ${featureName} : feature exists? `, AppConfig.settings.features.hasOwnProperty(featureName))
        // console.log(`-------------------------------------------------------------------------------------`)
        // console.log(`Getting in the feature Value check now ... `)
        if (AppConfig.settings.features.hasOwnProperty(featureName)) {
            // console.log(`-------------------------------------------------------------------------------------`)
            // console.log(`The feature --> ${featureName}  <-- has value: ${AppConfig.settings.features[featureName]}`)
            // console.log(`-------------------------------------------------------------------------------------`)
            // console.log(`FeatureOff result is ${!AppConfig.settings.features[featureName]}`)
            return !AppConfig.settings.features[featureName];
        }
        return true; // if feature not found, default to turned off
    }

    featureOn(featureName: string) {
        return !this.featureOff(featureName);
    }

    returnFeatureOnColumns(columns: any[]): string[] {
        let result = []
        columns.filter(col => {
            this.logger.info(col, !AppConfig.settings.features[col] && !AppConfig.settings.features.hasOwnProperty(col))
            if (!AppConfig.settings.features[col] && !AppConfig.settings.features.hasOwnProperty(col)) {
                result.push(col)
            }
            if (AppConfig.settings.features[col] && AppConfig.settings.features.hasOwnProperty(col)) {
                result.push(col)
            }
            return col
        })
        result = result.filter(this._onlyUnique);
        return result;
    }

    private _onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
}